import React, {useEffect} from 'react';
import {useAppDispatch} from "../app/hooks";
import {Button, Divider, Image, Typography} from "antd";
import {setKichiId, setMode} from "../features/omikuji/omikujiSlice";
import {API} from "aws-amplify";

export function Screen2_Top(props: any) {
    const dispatch = useAppDispatch();
    const onClickStart = () => {
        if ( window.confirm("マイクを使用します")){
            var constraints = {audio: true, video: false}
            navigator.mediaDevices.getUserMedia(constraints).then(()=>{
            })
        }
    }
    let hasSent: boolean = false
    let isPosting: boolean = false
    useEffect(() => {
        if (!hasSent) {
            hasSent = true;
            const myInit = {
                body: {
                    uuid: "aaa",
                }
            }
            API.post("log2api", "/ranking", myInit).then(async (response) => {
                if (isPosting) return
                isPosting = true
                // console.log(response)
            })
            // API.get("omikujimage", "/img", myInit).then(async (response) => {
            //     if (isPosting) return
            //     isPosting = true
            //     console.log(response)
            // })
        }

    })
    return <>
        <p>
            <Image
                src="/images/omikuji_fin.png"
                preview={false}
                alt="AIおみくじ2023"
            />
        </p>
        {/*<p>*/}
        {/*    <Image src="https://vsibd8xq0i.execute-api.ap-northeast-1.amazonaws.com/dev/img" />*/}
        {/*</p>*/}

        <p>上手に二拍手をしよう👏👏</p>
        <p>AIが実際の音で判定してくれるよ</p>
        <Button onClick={()=>{
            dispatch(setMode("mode5_Pray"))
        }
        }>おみくじを引く</Button>
        <Divider />
        <Typography.Paragraph>
            <p>QRコードでアクセスする</p>
            <Image src="/images/aiqr.png" preview={false} style={{maxWidth: "120px"}}/>
        </Typography.Paragraph>
    </>
}
